// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginForm_wrapper__Wv2na","block":"LoginForm_block__8fTiz","form":"LoginForm_form__drzVg","body":"LoginForm_body__7e+1+","footer":"LoginForm_footer__hR5if"};